import { Box, Flex, Float, Image, Text } from '@chakra-ui/react';
import { onImageError } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';
import { SelectTokenDialog } from './SelectTokenDialog';

interface SelectTokenProps {
  currentAccount: any;
  value: any;
  placeholder?: string;
  onValueChange?: (value: any) => void;
}
export default function SelectToken({
  currentAccount,
  placeholder,
  value,
  onValueChange,
  ...props
}: SelectTokenProps) {
  const { t } = useTranslation();
  const placeholderText = placeholder ?? t('chat.selectCoinText');
  const [openSelectToken, setOpenSelectToken] = useState(false);

  return (
    <>
      <Box cursor="pointer" onClick={() => setOpenSelectToken(true)}>
        {value ? (
          <Flex
            alignItems="center"
            px="1.5"
            py="1"
            gap="1"
            bg="grey.50"
            borderRadius="40px"
            {...props}
          >
            <Box pos="relative">
              <Image
                src={value?.logo}
                alt="info"
                width="7"
                height="7"
                borderRadius="full"
                onError={onImageError}
              />
              <Float placement="bottom-end" offsetX="1" offsetY="1">
                <Image
                  src={value?.chainLogo}
                  alt="info"
                  width="3"
                  height="3"
                  borderRadius="full"
                />
              </Float>
            </Box>
            <Box fontSize="sm" fontWeight="medium" color="fg">
              {value?.symbol}
            </Box>
          </Flex>
        ) : (
          <Text>{placeholderText}</Text>
        )}
      </Box>
      <SelectTokenDialog
        value={value}
        isOpen={openSelectToken}
        setIsOpen={setOpenSelectToken}
        currentAccount={currentAccount}
        setSelectedToken={(value) => {
          onValueChange?.(value);
        }}
      ></SelectTokenDialog>
    </>
  );
}
